/* Steady Freddy — Homepage 2025 — Hero: GSAP + ScrollTrigger on desktop (≥901px) only; LP uses static CSS */
(function () {
  'use strict';

  function domLiteMode() {
    return document.documentElement.hasAttribute('data-sf-hp-lite');
  }

  var CTA_BASE = 'Last Longer';

  function createArrow() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('width', '18');
    svg.setAttribute('height', '18');
    svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M5 12h14M13 5l7 7-7 7');
    svg.appendChild(path);
    return svg;
  }

  function setAtcWithArrow(btn, line) {
    if (!btn) return;
    var text = (line || CTA_BASE).replace(/\s+/g, ' ').trim();
    btn.textContent = text + ' ';
    btn.appendChild(createArrow());
  }

  function setStickyCtaText(btn, price) {
    if (!btn) return;
    var t = 'Add to cart';
    if (price) t += ' — ' + price;
    btn.textContent = t;
  }

  function syncActivePlanCTA() {
    var row = document.querySelector('.sf-buy__row.is-active');
    var atc = document.getElementById('sf-atc-btn');
    var sticky = document.getElementById('sf-sticky-atc-btn');
    var meta = document.getElementById('sf-sticky-meta');
    if (!row) return;
    var price = row.getAttribute('data-price') || '';
    var sub = (row.getAttribute('data-sf-sticky-meta') || '').replace(/&amp;/g, '&');
    var withPrice = price ? CTA_BASE + ' — ' + price : CTA_BASE;
    setAtcWithArrow(atc, withPrice);
    setStickyCtaText(sticky, price);
    if (meta && sub) {
      meta.textContent = sub;
      /* The active row already renders its own compare-at price, guarded on
         blank, so mirror that into the sticky bar rather than recomputing it.
         .sf-sticky__meta s is already styled for exactly this. Some layouts
         (the simple row) bake "was <price>" into the meta string themselves,
         hence the indexOf guard - otherwise the price would appear twice. */
      var sfStrikeEl = row.querySelector('.sf-buy__strike, .sf-card__price s, .sf-simple__was');
      var sfWas = sfStrikeEl ? sfStrikeEl.textContent.trim() : '';
      if (sfWas && sub.indexOf(sfWas) === -1) {
        var sfWasEl = document.createElement('s');
        sfWasEl.textContent = sfWas;
        /* Sit the "was" price immediately after the current price rather than
           trailing the whole string, so it reads "$269.99 $449.95 - 5 Bottles"
           and not "...5 Bottles $449.95". sub is always "PRICE - LABEL". */
        var sfCut = sub.indexOf(' \u00b7 ');
        if (sfCut > -1) {
          meta.textContent = sub.slice(0, sfCut);
          meta.appendChild(sfWasEl);
          meta.appendChild(document.createTextNode(sub.slice(sfCut)));
        } else {
          meta.appendChild(sfWasEl);
        }
      }
    }
  }

  /* ── Countdown timer ───────────────────────────── */
  function initCountdown() {
    var el = document.getElementById('sf-timer');
    if (!el) return;
    var HOURS = 8;
    var key = 'sf-deadline-2025';
    var stored = parseInt(localStorage.getItem(key) || '0', 10);
    if (!stored || stored <= Date.now()) {
      stored = Date.now() + HOURS * 3600 * 1000;
      localStorage.setItem(key, String(stored));
    }
    function tick() {
      var rem = stored - Date.now();
      if (rem < 0) rem = 0;
      var h = Math.floor(rem / 3600000);
      var m = Math.floor((rem % 3600000) / 60000);
      var s = Math.floor((rem % 60000) / 1000);
      el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    function pad(n) { return String(n).padStart(2, '0'); }
    tick();
    setInterval(tick, 1000);
  }

  /* ── Header scroll ─────────────────────────────── */
  function initHeader() {
    var header = document.querySelector('.sf-header');
    if (!header) return;
    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Mobile nav ────────────────────────────────── */
  function initMobileNav() {
    var toggle = document.getElementById('sf-nav-toggle');
    var nav = document.getElementById('sf-mobile-nav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { nav.classList.remove('is-open'); });
    });
  }

  /* ── FAQ accordion ─────────────────────────────── */
  function initFaq() {
    var items = document.querySelectorAll('.sf-faq__item');
    items.forEach(function (item) {
      var btn = item.querySelector('.sf-faq__q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (i) { i.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  /* ── Product gallery ───────────────────────────── */
  function initGallery() {
    var mainImg = document.getElementById('sf-product-hero-img');
    var thumbs = document.querySelectorAll('.sf-product__thumb');
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.src;
        if (src) mainImg.src = src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ── Plan selector + CTA text ──────────────────── */
  function initPlanSelector() {
    var rows = document.querySelectorAll('.sf-buy__row');
    if (!rows.length) return;
    rows.forEach(function (row) {
      row.addEventListener('click', function () {
        rows.forEach(function (r) { r.classList.remove('is-active'); });
        row.classList.add('is-active');
        syncActivePlanCTA();
      });
    });
    syncActivePlanCTA();
  }

  /* ── Add to cart ───────────────────────────────── */
  function initAddToCart() {
    document.querySelectorAll('[data-sf-atc]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var activeRow = document.querySelector('.sf-buy__row.is-active');
        var variantId = activeRow ? activeRow.dataset.variantId : btn.dataset.variantId;
        var sellingPlanId = activeRow ? activeRow.dataset.sellingPlanId : null;
        var qtyParsed = activeRow && activeRow.dataset.quantity ? parseInt(activeRow.dataset.quantity, 10) : 1;
        var quantity = qtyParsed >= 1 && qtyParsed <= 99 ? qtyParsed : 1;
        /* No variant to add: fall back to the first row that has one rather than
           navigating away. The old fallback sent shoppers to the section's own
           product page, or to a hardcoded /products/delay-spray that 404s. */
        if (!variantId) {
          var firstRow = document.querySelector('.sf-buy__row[data-variant-id]:not([data-variant-id=""])');
          variantId = firstRow ? firstRow.dataset.variantId : null;
          if (firstRow && firstRow.dataset.quantity) {
            var fq = parseInt(firstRow.dataset.quantity, 10);
            if (fq >= 1 && fq <= 99) quantity = fq;
          }
        }
        if (!variantId) { return; }
        btn.classList.add('is-loading');
        var body = { id: parseInt(variantId, 10), quantity: quantity };
        if (sellingPlanId) {
          var sp = parseInt(sellingPlanId, 10);
          if (!isNaN(sp)) body.selling_plan = sp;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart add failed');
            return res.json();
          })
          .then(function () {
            btn.classList.remove('is-loading');
            /* UpCart is the drawer here. It patches fetch and opens itself on
               /cart/add.js, so the events below are belt and braces for any
               listener that wants them. Nothing navigates. */
            document.dispatchEvent(new CustomEvent('cart:open'));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            try {
              if (window.upcart && typeof window.upcart.refresh === 'function') window.upcart.refresh();
            } catch (err) {}
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var counts = document.querySelectorAll('.sf-iconbtn__count');
                counts.forEach(function (c) { c.textContent = cart.item_count; });
              });
          })
          .catch(function () {
            /* Never navigate on failure. This used to send shoppers to the
               section's product page, or to a hardcoded /products/delay-spray
               which 404s, which is where the "add to cart opens a PDP" came
               from: UpCart patches fetch, and any rejection landed here. */
            btn.classList.remove('is-loading');
          });
      });
    });
  }

  /* ── Sticky ATC (show past hero, hide when footer enters viewport) ─ */
  function initStickyATC() {
    var bar = document.getElementById('sf-sticky-bar');
    var hero = document.querySelector('.sf-hero');
    if (!hero) hero = document.getElementById('sf-product');
    var footer = document.querySelector('.sf-footer');
    if (!bar || !hero) return;

    var pending;

    function update() {
      var heroR = hero.getBoundingClientRect();
      // While any part of the hero is still in view below the top edge, keep bar hidden
      if (heroR.bottom > 0) {
        bar.classList.remove('is-visible');
        return;
      }
      if (footer) {
        var fr = footer.getBoundingClientRect();
        var vh = document.documentElement.clientHeight;
        if (fr.top < vh) {
          bar.classList.remove('is-visible');
          return;
        }
      }
      bar.classList.add('is-visible');
    }
    function onScroll() {
      if (pending) return;
      pending = requestAnimationFrame(function () {
        pending = null;
        update();
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }


  function initProblemBignum() {
    var sec = document.querySelector('[data-sf-problem]');
    var el = document.querySelector('[data-sf-problem-bignum]');
    if (!sec || !el) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.classList.add('is-animated');
      return;
    }
    if (!window.IntersectionObserver) {
      el.classList.add('is-animated');
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          el.classList.add('is-animated');
          obs.unobserve(sec);
        });
      },
      { threshold: 0.15 }
    );
    obs.observe(sec);
  }

  function initStudySection() {
    var section = document.querySelector('[data-sf-study]');
    var fill = document.querySelector('[data-sf-study-fill]');
    var counter = document.querySelector('[data-sf-study-counter]');
    if (!section || !fill || !counter || !window.IntersectionObserver) return;
    var done = false;
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting || done) return;
          done = true;
          obs.unobserve(e.target);
          fill.style.width = '90%';
          fill.style.transition = 'width 1.6s cubic-bezier(0.22, 1, 0.36, 1)';
          var target = 496;
          var t0 = performance.now();
          var dur = 1600;
          function step(now) {
            var p = Math.min(1, (now - t0) / dur);
            var ease = 1 - Math.pow(1 - p, 1.2);
            counter.textContent = String(Math.round(ease * target));
            if (p < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        });
      },
      { threshold: 0.12 }
    );
    obs.observe(section);
  }

  function runBaValCount(el, targetNum, durationMs) {
    if (!el) return;
    var t0 = performance.now();
    var dur = durationMs != null ? durationMs : 1000;
    function step(now) {
      var p = Math.min(1, (now - t0) / dur);
      var ease = 1 - Math.pow(1 - p, 1.2);
      el.textContent = String(Math.round(ease * targetNum));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initBarAnimations() {
    var bars = document.querySelectorAll('.sf-ba__bar .fill');
    if (!bars.length || !window.IntersectionObserver) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var bar = entry.target;
          var w = bar.getAttribute('data-target-width') || bar.style.width;
          if (w) bar.style.width = w;
          var row = bar.closest('.sf-ba__bar');
          var vEl = row && row.querySelector('.sf-ba__val-num');
          if (vEl) {
            var n = parseInt(vEl.getAttribute('data-sf-ba-val') || '0', 10);
            if (n) runBaValCount(vEl, n, 1000);
          }
          observer.unobserve(bar);
        }
      });
    }, { threshold: 0.2 });
    bars.forEach(function (bar) {
      var target = bar.getAttribute('data-target-width') || bar.style.width;
      if (!target) return;
      bar.setAttribute('data-target-width', target);
      bar.style.width = '0';
      bar.style.transition = 'width 1s var(--ease-out)';
      observer.observe(bar);
    });
  }

  /* ── Hero: static clock labels (step 1 active). GSAP handles motion on desktop only. ─ */
  function initHeroStatic() {
    if (domLiteMode()) return;
    var labels = document.querySelectorAll('[data-sf-clock-step]');
    if (!labels.length) return;
    labels.forEach(function (label) {
      var step = label.getAttribute('data-sf-clock-step');
      label.classList.toggle('is-active', step === '1');
    });
  }

  /* ── Hero: GSAP entrance + scroll scrub + disc float (desktop breakpoint only) ─ */
  function initHeroGsapDesktop() {
    if (domLiteMode()) return;
    var heroEl = document.getElementById('sf-hero');
    if (heroEl && heroEl.getAttribute('data-sf-hero-gsap') === 'false') return;
    if (typeof gsap === 'undefined' || !window.ScrollTrigger) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    gsap.registerPlugin(ScrollTrigger);

    var spinDeg = 720;
    if (heroEl) {
      var raw = heroEl.getAttribute('data-sf-hero-spin');
      var parsed = raw ? parseFloat(raw) : NaN;
      if (!isNaN(parsed) && parsed > 0) spinDeg = parsed;
    }

    var mm = gsap.matchMedia();

    mm.add('(min-width: 901px)', function () {
      var visual = document.getElementById('sf-hero-visual');
      var product = document.getElementById('sf-hero-product');
      var disc = document.getElementById('sf-hero-disc');
      var burst = document.getElementById('sf-hero-burst');
      if (!visual || !product || !disc || !burst) {
        return function () {};
      }

      var chips = visual.querySelectorAll('.sf-hero__chip');

      gsap.set(product, { opacity: 1 });
      gsap.set(burst, { opacity: 1 });
      if (chips.length) gsap.set(chips, { opacity: 1, x: 0 });

      var tl = gsap.timeline({ defaults: { ease: 'power3.out' } });
      tl.fromTo(
        product,
        { y: -80, scale: 0.88 },
        { y: 0, scale: 1, duration: 1.2, ease: 'elastic.out(1,0.6)' }
      ).fromTo(
        burst,
        { scale: 0, rotation: -30 },
        { scale: 1, rotation: -8, duration: 0.8, ease: 'back.out(2.2)' },
        '-=0.6'
      );
      if (chips.length) {
        tl.fromTo(chips, { x: 40 }, { x: 0, duration: 0.5, stagger: 0.12 }, '-=0.7');
      }

      var floatTween = gsap.to(disc, {
        y: '+=10',
        duration: 3.2,
        ease: 'sine.inOut',
        yoyo: true,
        repeat: -1,
      });

      var scrollTweens = [
        gsap.to(product, {
          rotation: spinDeg,
          scale: 2.15,
          y: 240,
          x: 48,
          ease: 'none',
          immediateRender: false,
          scrollTrigger: {
            trigger: '.sf-hero',
            start: 'top top',
            end: '+=160%',
            scrub: 0.4,
          },
        }),
        gsap.to(disc, {
          yPercent: 30,
          scale: 1.35,
          rotation: -90,
          ease: 'none',
          immediateRender: false,
          scrollTrigger: { trigger: '.sf-hero', start: 'top top', end: '+=160%', scrub: true },
        }),
        gsap.to(burst, {
          rotation: -180,
          scale: 1.5,
          y: -60,
          ease: 'none',
          immediateRender: false,
          scrollTrigger: { trigger: '.sf-hero', start: 'top top', end: '+=160%', scrub: true },
        }),
      ];

      return function () {
        floatTween.kill();
        tl.kill();
        scrollTweens.forEach(function (t) {
          if (t && t.scrollTrigger) t.scrollTrigger.kill();
          if (t && t.kill) t.kill();
        });
      };
    });
  }

  /* ── Init ──────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initCountdown();
    initHeader();
    initMobileNav();
    initFaq();
    initGallery();
    initPlanSelector();
    initAddToCart();
    initStickyATC();
    initBarAnimations();
    initStudySection();
    initProblemBignum();
    if (!domLiteMode()) {
      initHeroStatic();
      initHeroGsapDesktop();
    }
  });
})();
